import { ErrorBoundary, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Center } from 'native-base';

import { BlockedResource } from '../../../../constants';
import { CardItem } from '../CardItem';

interface CardBlockProps {
  isLoading: boolean;
  data: BlockedResource[];
  onRemoveBlock: (id: number) => void;
}

export const CardBlock = ({ isLoading, data, onRemoveBlock }: CardBlockProps) => {
  if (isLoading) {
    return Array.from({ length: 3 }).map((_, index) => (
      <VStack py={Spacing['inline.xxxs']} space={Spacing['stack.xxxs']} key={index}>
        <CardItem
          blockedResource={{ item: [], id: 0, canDelete: false }}
          onRemoveBlock={onRemoveBlock}
          isLoading={isLoading}
        />
      </VStack>
    ));
  }

  if (data?.length === 0 && !isLoading) {
    return (
      <Center h={'400px'}>
        <ErrorBoundary
          errorIconOrIllustration="NotFoundIllustration"
          errorTitle="Este produto ainda não possui nenhum bloqueio"
          errorMessage="Caso queira realizar um novo bloqueio, clique no botão à direita."
        />
      </Center>
    );
  }

  return (
    <VStack py={Spacing['inline.xxxs']} space={Spacing['stack.xxxs']}>
      {data.map((item, index) => (
        <CardItem
          blockedResource={item}
          key={index}
          onRemoveBlock={onRemoveBlock}
          isLoading={isLoading}
        />
      ))}
    </VStack>
  );
};
